import React from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from "react-redux";

import { setSampler } from "../mods/iframe/redux/actions/index";

import IconSampler from '../svg/IconSampler';

function ConnectedButtonSampler({ style, enable }) {
  const dispatch = useDispatch();
  const onClick = () => { dispatch(setSampler(!enable)); }
  const color = enable ? '#4EDF84' : '#808183';
  return <IconSampler
    id={`menu_sampler`}
    className={`topbutton`}
    style={{padding: `12px 10px 7px 7px`}}
    color={color}
    onClick={onClick}
  />
}

ConnectedButtonSampler.propTypes = {
  style: PropTypes.object,
  enable: PropTypes.bool
}

const ButtonSampler = connect(
  state => ({
    enable: state.ISampler
  })
)(ConnectedButtonSampler);

export default ButtonSampler;
